import { Box } from "@mui/material";
import React from "react";
import { RouteProps } from "react-router-dom";

import { TermsOfService } from "routing/TermsOfService";
import { AuthFlow, UserProps } from "types/users";

export function TermsOfServiceGate(props: UserProps & RouteProps) {
  const { user, children } = props;

  if (user && user.auth_flow === AuthFlow.COGNITO && !user.accepted_tos) {
    // If the user hasn't accepted the terms yet,
    // show the Terms of Service widget instead of the regular child page.
    // This seems simpler than a redirect, and then trying to figure out how to
    // un-redirect back to the original desired page.
    return <TermsOfService />;
  }

  return <Box sx={{ height: "100%" }}>{children}</Box>;
}
